/* sections/truerim-cl-hero.liquid: section script (moved out of the section's javascript block 2026-10-22 so it loads only on pages that use
   the section). Loaded with defer by the section; runs once per page, like Shopify's compiled bundle did. */
/* ==== js:sections/truerim-cl-hero.liquid ==== */
(function () {
  var ran = window.__trRan = window.__trRan || {};
  if (ran['truerim-cl-hero']) return;
  ran['truerim-cl-hero'] = 1;
/* truerim-cl-hero: hero video (sound toggle, "Tap for sound" hint, play button under reduced motion), the 3D logo's sheen
   mask, pointer tilt (desktop pointers only) and pausing every loop while the hero is off screen. */
(function boot() {
  if (!window.TRCL) { document.addEventListener('trcl:ready', boot, { once: true }); return; }
  TRCL.section('[data-trcl-section="hero"]', function (root) {
    var undo = [];
    var v = root.querySelector('.trcl-hero__media video');
    var userPaused = false;

    /* ---- off-screen pause: CSS loops (class is-off) and the autoplaying video */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var off = !e.isIntersecting;
          root.classList.toggle('is-off', off);
          if (!v || TRCL.still || userPaused) return;
          if (off) { try { v.pause(); } catch (x) {} }
          else { try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (x) {} }
        });
      }, { threshold: 0 });
      io.observe(root);
      undo.push(function () { io.disconnect(); });
    }

    /* ---- 3D logo: sheen mask = the front image's own file (already downloaded) */
    var front = root.querySelector('.trcl-hero__logo-img--front'), sheen = root.querySelector('[data-trcl-sheen]');
    if (front && sheen && !TRCL.still) {
      var setMask = function () {
        var src = front.currentSrc || front.src;
        if (!src) return;
        sheen.style.setProperty('--trcl-mask', 'url("' + src.replace(/"/g, '%22') + '")');
        sheen.classList.add('is-on');
      };
      if (front.complete && front.naturalWidth) setMask(); else front.addEventListener('load', setMask, { once: true });
    }

    /* ---- pointer tilt (desktop): the logo leans up to 10deg toward the pointer */
    var tilt = root.querySelector('[data-trcl-tilt]');
    if (tilt && !TRCL.still && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var pend = null, raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      var onMove = function (e) {
        var r = root.getBoundingClientRect(), lr = tilt.getBoundingClientRect();
        var dx = (e.clientX - (lr.left + lr.width / 2)) / Math.max(1, r.width / 2);
        var dy = (e.clientY - (lr.top + lr.height / 2)) / Math.max(1, r.height / 2);
        dx = Math.max(-1, Math.min(1, dx)); dy = Math.max(-1, Math.min(1, dy));
        if (pend) return;
        pend = raf(function () {
          pend = null;
          tilt.style.setProperty('--trcl-ry', (dx * 10).toFixed(2) + 'deg');
          tilt.style.setProperty('--trcl-rx', (-dy * 8).toFixed(2) + 'deg');
        });
      };
      var onLeave = function () { tilt.style.setProperty('--trcl-ry', '0deg'); tilt.style.setProperty('--trcl-rx', '0deg'); };
      root.addEventListener('mousemove', onMove);
      root.addEventListener('mouseleave', onLeave);
      undo.push(function () { root.removeEventListener('mousemove', onMove); root.removeEventListener('mouseleave', onLeave); });
    }

    if (!v) return function () { undo.forEach(function (f) { f(); }); };

    /* ---- video */
    var btn = root.querySelector('[data-trcl-sound]'), hint = root.querySelector('[data-trcl-hint]'), play = root.querySelector('[data-trcl-play]');
    var label = btn && btn.querySelector('[data-trcl-sound-label]');
    var timer = null;
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    var showPlay = function () {
      if (!play) { v.controls = true; return; }
      play.hidden = false;
      if (btn) btn.hidden = true;
      if (hint) hint.hidden = true;
    };
    var startVideo = function () {
      try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () { showPlay(); }); } catch (e) { showPlay(); }
    };
    if (TRCL.still) {
      /* reduced motion: no autoplay; the poster stays until the shopper presses Play */
      try { v.pause(); } catch (e) {}
      v.removeAttribute('autoplay');
      v.autoplay = false;
      showPlay();
    } else {
      startVideo();
    }
    var hideHint = function () { if (hint) hint.hidden = true; clearTimeout(timer); };
    var render = function () {
      if (!btn) return;
      btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      if (label) label.textContent = v.muted ? label.getAttribute('data-off') : label.getAttribute('data-on');
    };
    var setMuted = function (m) {
      v.muted = m;
      if (!m) startVideo();
      hideHint();
      render();
    };
    if (play) play.addEventListener('click', function (e) {
      e.stopPropagation();
      userPaused = false;
      v.loop = true;
      play.hidden = true;
      if (btn) btn.hidden = false;
      startVideo();
    });
    if (btn && !TRCL.still) { btn.hidden = false; btn.addEventListener('click', function (e) { e.stopPropagation(); setMuted(!v.muted); }); }
    else if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); setMuted(!v.muted); });
    if (hint && !TRCL.still) {
      hint.hidden = false;
      hint.addEventListener('click', function (e) { e.stopPropagation(); setMuted(false); });
      timer = setTimeout(hideHint, 15000);
    }
    var onVideo = function () {
      if (v.controls || (play && !play.hidden)) return;
      if (btn) setMuted(!v.muted);
    };
    v.addEventListener('click', onVideo);
    render();
    undo.push(function () { clearTimeout(timer); v.removeEventListener('click', onVideo); });
    return function () { undo.forEach(function (f) { f(); }); };
  });
})();
})();
/* ==== end js:sections/truerim-cl-hero.liquid ==== */
